import { fetchDataCarModel } from "@Services/api";
import Tracking from "@t8891/tracking";

const TRACKING_CONFIG_EXPOSURE = {
  'newCar:photoModel-compare.html':{
    key:"MODEL_YEAR_IDS",
    next_spm:"3.622.948.2634",
    type: "myid"
  },
  'newCar:pk/comprehensive':{
    key:"MODEL_YEAR_IDS",
    next_spm:"3.721.949.2635",
    type: "myid"
  },
  'newCar:{brand}/{kind}/Specification.html':{
    key:"MODEL_YEAR_ID_STRING",
    next_spm:"3.266.944.2625",
    type: "myid"
  },
  'newCar:{brand}/{kind}-{year}/Specification.html':{
    key:"MODEL_YEAR_ID_STRING",
    next_spm:"3.266.944.2625",
    type: "myid"
  }
}

// MODEL_YEAR_ID_STRING
const paramsMap = ()=>{

}

async function userBehavedTrackingExposure(tracking: Tracking,spm?:string) {
  if(window.page_route === "newCar:movies/{id}"){
    carModelData?.map((item:any)=>{
      const { brandId, kindId, modelId, myid, brandName, kindName, modelName, modelYear } = item;
      const params = {
        brand_id: brandId,
        kind_id: kindId,
        myid: myid,
        model_id: modelId,
        model_year: modelYear,
        kind: kindName,
        brand: brandName,
        model_year_fullname: modelName,
      };
      tracking.exposure("7.263.962.2655",params);
    return
    })
  }
  let isExposure = TRACKING_CONFIG_EXPOSURE[window.page_route];
  if(isExposure && !!window[isExposure.key]) {
    let parmas = {};
    if(isExposure.type === "myid") {
      parmas = {myid:window[isExposure.key]};
    }
    
    let res = await fetchDataCarModel(parmas);
    
    if(res?.status === 12000 && res?.data?.list.length > 0  ) {
      
      res?.data?.list.map((item:any)=>{
        const { brandId, kindId, modelId, myid, brandName, kindName, modelName, modelYear } = item;
        const params = {
          brand_id: brandId,
          kind_id: kindId,
          myid: myid,
          model_id: modelId,
          model_year: modelYear,
          kind: kindName,
          brand: brandName,
          model_year_fullname: modelName,
        };
        let next_spm = spm || isExposure.next_spm;
        
        tracking.exposure(next_spm,params);
      })
    } 
    }
}

export default userBehavedTrackingExposure;
